import React from 'react';
import codepost from '../../images/js-logo.png';
import './javascript.css';
import {Link} from 'react-router-dom';
import {useEffect} from "react";
import AOS from 'aos';
import 'aos/dist/aos.css';


function JavaScript() {

  useEffect(() => {
    AOS.init();
  }, [])

  return (
  <section className="javascript-blog" id="html-blog">
   <div className="javascript-blog-container">
   
    <div className="javascript-blog-info" data-aos="fade-left">
      <img src={codepost} alt="" />
      <div className="javascript-blog-content">
        {/* <span className="javascript-blog-date"> April 25th, 2022 </span> */}
        <Link to="/JsIntro"><h3 className="js-intro-title"> Intro to JavaScript </h3></Link>
        <p className="javascript-blog-description"> 
        JavaScript is a versatile, high-level, and dynamic programming language primarily used for 
        front-end web development. JavaScript enables web developers to create interactive and responsive websites
         by adding behavior and functionality to web pages.</p>
        <Link to="/JsIntro"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="javascript-blog-info" data-aos="zoom-in">
      <img src={codepost} alt="" />
      <div className="javascript-blog-content">
      {/* <span className="javascript-blog-date"> April 25th, 2022 </span> */}
      <Link to="/JsVarPost"><h3 className="js-intro-title"> Variables & Operators </h3></Link>
        <p className="javascript-blog-description"> 
        Variables, operators, and data types are the buildingblocks of Javascript. They allow you to
         manipulate data, control program flow, and build complex applications. Knowing these 
         fundamental concepts are at the core of creating dynamic and interactive web applications. 
      </p>
      <Link to="/JsVarPost"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="javascript-blog-info" data-aos="fade-right">
      <img src={codepost} alt="" />
      <div className="javascript-blog-content">
      {/* <span className="javascript-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Dom"><h3 className="js-intro-title"> DOM </h3></Link>
        <p className="javascript-blog-description"> 
        The Document Object Model (DOM) is the foundation of dynamic web development, 
        enabling JavaScript to interact with HTML and CSS to create rich, interactive 
        web experiences. In this blog post, we'll delve into the intricacies of the 
        JavaScript DOM, uncovering its structure, traversal methods, manipulation
        techniques, and event handling capabilities.
        </p>
        <Link to="/Dom"><button className="button"> Read More </button></Link>
      </div>
    </div>


    <div className="javascript-blog-info" data-aos="zoom-in">
      <img src={codepost} alt="" />
      <div className="javascript-blog-content">
      {/* <span className="javascript-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Functions"><h3 className="js-intro-title"> Functions </h3></Link>
        <p className="javascript-blog-description"> 
             JavaScript functions are a fundamental building block of JavaScript, providing a way to 
              structure code, promote reusability, and encapsulate logic.  In this blog post, we will dive into
              the world of JavaScript functions, exploring their syntax, usage, and the myriad ways they
              contribute to building dynamic and interactive web applications.</p>
        <Link to="/Functions"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="javascript-blog-info" data-aos="zoom-in">
      <img src={codepost} alt="" />
      <div className="javascript-blog-content">
      {/* <span className="javascript-blog-date"> April 25th, 2022 </span> */}
        <Link to="/ControlStructures"><h3 className="js-intro-title"> If Statements & Loops </h3></Link>
        <p className="javascript-blog-description"> 
        If Statements or Conditional statements are fundamental to programming, enabling 
        developers to make decisions and control the flow of their code based on certain 
        conditions. In JavaScript, one of the most commonly used conditional statements 
        is the "if" statement. In this blog post, we'll delve into the intricacies of if
         statements exploring their syntax, usage, and best practices.</p>
        <Link to="/ControlStructures"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="javascript-blog-info" data-aos="zoom-in">
      <img src={codepost} alt="" />
      <div className="javascript-blog-content">
      {/* <span className="javascript-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Arrays"><h3 className="js-intro-title"> Arrays </h3></Link>
        <p className="javascript-blog-description"> Arrays is a data structure that
         allows you to store and manipulate a collection of values, such as numbers, strings, objects,
          or even other arrays. Arrays are commonly used to organize and work with data in a structured 
          way. Here are some key characteristics of JavaScript arrays:
       </p>
        <Link to="/Arrays"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="javascript-blog-info" data-aos="zoom-in">
      <img src={codepost} alt="" />
      <div className="javascript-blog-content">
      {/* <span className="javascript-blog-date"> April 25th, 2022 </span> */}
        <Link to="/ObjectProgram"><h3 className="js-intro-title"> Object Oriented Programming </h3></Link>
        <p className="javascript-blog-description"> 
        Object-oriented programming (OOP) is a powerful paradigm for structuring code,
         promoting modularity, and enhancing code reusability. A versatile
          and dynamic language, OOP principles are implemented using objects, prototypes,
           and inheritance. In this guide, we'll explore the fundamentals of 
           object-oriented JavaScript programming, from creating objects to implementing
            inheritance and beyond.</p>
        <Link to="/ObjectProgram"><button className="button"> Read More </button></Link>
      </div>
    </div>
    
    <div className="javascript-blog-info" data-aos="zoom-in">
      <img src={codepost} alt="" />
      <div className="javascript-blog-content">
      {/* <span className="javascript-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Asynchro"><h3 className="js-intro-title"> AJAX </h3></Link>
        <p className="javascript-blog-description"> 
        AJAX is a set of web development techniques that enable web pages to interact with 
        a web server in the background, without requiring a full page refresh. It allows 
        data to be exchanged asynchronously between the browser and the server, enhancing 
        the user experience by providing real-time updates and interactivity.</p>
        <Link to="/Asynchro"><button className="button"> Read More </button></Link>
      </div>
    </div>

    <div className="javascript-blog-info" data-aos="zoom-in">
      <img src={codepost} alt="" />
      <div className="javascript-blog-content">
      {/* <span className="javascript-blog-date"> April 25th, 2022 </span> */}
        <Link to="/Modules"><h3 className="js-intro-title"> Modules </h3></Link>
        <p className="javascript-blog-description"> 
        Modules are a powerful tool for organizing, reusing, and scaling JavaScript 
        codebases. Modules allow developers to break down applications into modular components,
         which allows for an improvement of maintainability, enhance code reuse, and manage complexity
          effectively. Whether you're building a small project or a large-scale
           application, understanding and leveraging modules in JavaScript can 
           significantly improve your development workflow and the quality of your code.</p>
        <Link to="/Modules"><button className="button"> Read More </button></Link>
      </div>
    </div>

  </div>
</section>
  )
}

export default JavaScript;



